module.exports = __webpack_public_path__ + "img/event_page_1.cc22c51d.png";